module.exports = __webpack_public_path__ + "static/media/school-children-learning-South-Africa.696f9da4.jpg";